module.exports = __webpack_public_path__ + "img/product_21.6fb0d4c.webp";